<template>
    <div class="card-body px-0 pt-0 pb-3">
        <div class="table-responsive">
            <el-table border :data="this.data" style="width: 100%" class="el-table-css">
                <el-table-column label="Buraxılıb" width="90" align="center">
                    <template #default="scope">
                        <i v-if="scope.row.issued == true" style="font-size: 18px;"
                            class="bi bi-check-lg text-excel"></i>
                    </template>
                </el-table-column>
                <el-table-column label="SŞ nömrəsi" width="150">
                    <template #default="scope">
                        <div class="row">
                            <div class="col-sm-12">
                                <a class="number-link" style="color: #007bff;"
                                    @click="GoToAddendum(scope.row.addId)">{{
                                        scope.row.addNumber }}</a>
                            </div> 
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="addNumber" label="Əlavə №" width="120" />
                <el-table-column prop="addDateStr" label="Tarix" width="120" />
                <el-table-column prop="addCategoryName" label="Kateqoriya" width="300" />
                <el-table-column prop="addTypeName" label="Dəyişiklər" />
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: Array
    },
    methods: {
        GoToAddendum(value) {
            window.open(window.location.origin + '/documents/addendum/' + this.$route.path.split("/")[3] + '/' + value, "_blank");
        }, 
    }
}
</script>
<style scoped>
.diaq-row {
    --el-table-tr-bg-color: #f8caca !important;
}
</style>